export const SPENMO_SUPPORT = {
  ZENDESK_KEY: "7a908732-342f-4d85-91d7-cd09cab3492d",
};

export const JWT_TOKEN_ENDPOINT = "6DA61FE006CD980A35C44126FB7BAD1C00824CAE0024962AB7CD3AD937D45CB9";
